import { jsonLightReadStringPropertyValue } from "@msdyn365-commerce/retail-proxy";

export interface IDeliveryDateData {
    DeliveryDates?: Date[];
}

export class DeliveryDateDataExtensionClass implements IDeliveryDateData {
    // @ts-ignore
    public DeliveryDates: Date[];

    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore
        this.DeliveryDates = undefined;
        if (odataObject.DeliveryDates) {
            this.DeliveryDates = [];
            for (var i = 0; i < odataObject.DeliveryDates.length; i++) {
                if (odataObject.DeliveryDates[i]) {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.DeliveryDates[i] =
                        (odataObject.DeliveryDates[i] instanceof Date) ? odataObject.DeliveryDates[i]
                            : jsonLightReadStringPropertyValue(odataObject.DeliveryDates[i], 'Edm.DateTimeOffset', false);

                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.DeliveryDates[i] = undefined;
                }
            }
        }
    }
}